module.exports = __webpack_public_path__ + "static/media/Back Button.605cf0ce.png";